import { b2cCatalogUrl, config } from '../utils/constants/api.constants';
import { convertObjectToParams } from '../utils/utils';

const {
  inventory: {
    host,
    adminUtilsHost,
    api_version,
    inventory,
    pendingAction,
    pendingActionCount,
    auditTrail,
    internalMovement,
    logistic,
    bulk,
    nextHop,
    notification,
    hardRefresh,
    order,
    updateRegNo,
    key,
    spareKey,
    keyDetails,
    count,
    chassis,
    uploadChassis,
  },
  refurbishment: { baseUrl, inspection },
} = config.api;

export default (api) => {
  const onMarkDocumentDispatch = (apptID, dispatchBy, remarks, params) => {
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventoryAsset +
      '/apt-' +
      apptID +
      `/DOCUMENT/dispatched?dispatchBy=${dispatchBy}&dispatchRemarks=${remarks}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const onMarkDocumentReceived = (
    apptID,
    locationCode,
    remarks,
    slot,
    params
  ) => {
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventoryAsset +
      '/apt-' +
      apptID +
      `/DOCUMENT/${locationCode}/received?remarks=${remarks}&slot=${slot}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const onMarkDocumentLost = (apptID, remarks, params) => {
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventoryAsset +
      '/apt-' +
      apptID +
      `/DOCUMENT/lost?remarks=${remarks}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const onMarkDocumentPending = (apptID, reason, remarks, params) => {
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventoryAsset +
      '/apt-' +
      apptID +
      `/DOCUMENT/pending?remarks=${remarks}&assetPendingBy=${reason}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDocumentAuditLog = (params) => {
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.auditTrail +
      '/inventoryAsset';
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDocumentAuditLogCount = (params) => {
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.auditTrail +
      '/inventoryAsset/count';
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPendingPublishUpdatesAuditLog = (inventoryId, params) => {
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.auditTrail +
      config.api.inventory.inventory +
      '/' +
      inventoryId +
      config.api.inventory.pendingUpdates;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getCarDetails = (appointmentId) => {
    return new Promise((resolve, reject) => {
      api
        .get(`${b2cCatalogUrl()}/detail/v1/cars?appIds=${appointmentId}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateInventorySoldField = (appointmentId, params, rawData) => {
    const url = `${host}${api_version}${inventory}/apt-${appointmentId}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getInventoryRefurbDetails = (appointmentId, params) => {
    const url = `${baseUrl}${inspection}/${appointmentId}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getInventoryRefurbDetailsForID = (params) => {
    const url = `${baseUrl}${inspection}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPendingActions = (params) => {
    const url = `${host}${api_version}${pendingAction}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPendingActionsCount = (params) => {
    const url = `${host}${api_version}${pendingAction}${pendingActionCount}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPendingActionsAuditLog = (params) => {
    const url = `${host}${api_version}${auditTrail}${pendingAction}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPendingActionsAuditLogCount = (params) => {
    const url = `${host}${api_version}${auditTrail}${pendingAction}${pendingActionCount}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const setPendingAction = (params, rawData) => {
    const url = `${host}${api_version}${pendingAction}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getHelloArStatus = (appointmentId, params) => {
    const url = `${adminUtilsHost}${api_version}${inventory}/apt-${appointmentId}/helloARDetails`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateInventoryAttributes = (
    method,
    appointmentId,
    rawData = {},
    params = {}
  ) => {
    const url = `${host}${api_version}${inventory}/apt-${appointmentId}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api[method](url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateInventoryFlags = (appointmentId, params, rawData = {}) => {
    const url = `${host}${api_version}${inventory}/apt-${appointmentId}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const bulkInternalMovement = (params, rawData = {}) => {
    const url = `${host}${api_version}${inventory}${internalMovement}${bulk}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const bulkSetLogisticVendor = (params, rawData = {}) => {
    const url = `${host}${api_version}${inventory}${logistic}${bulk}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const bulkMoveOutAndPark = (params, rawData = {}) => {
    const url = `${host}${api_version}${inventory}${bulk}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const bulkSendVendorAssignedEmail = (params) => {
    const url = `${host}${api_version}${notification}/VENDOR_ASSIGNED${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const createNextHop = (id, params, rawData = {}) => {
    const url = `${host}${api_version}${inventory}/${id}${nextHop}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .put(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const directStockIn = (aptId, params, rawData = {}) => {
    const url = `${host}${api_version}${inventory}/apt-${aptId}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const hardRefreshInventory = (aptId) => {
    const url = `${adminUtilsHost}${api_version}${inventory}${hardRefresh}/apt-${aptId}`;
    return new Promise((resolve, reject) => {
      api
        .put(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getInventoryOrderIds = (aptId, params) => {
    const url = `${host}${api_version}${inventory}/apt-${aptId}${order}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateRegistrationNumber = (aptId, params, rawData = {}) => {
    const url = `${host}${updateRegNo}/apt-${aptId}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .put(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getKeyManagementAuditTrail = (inventoryId, params) => {
    const url = `${host}${api_version}${auditTrail}${keyDetails}/${inventoryId}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getKeyManagementAuditTrailCount = (inventoryId, params) => {
    const url = `${host}${api_version}${auditTrail}${count}/${inventoryId}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const handleKeyMovement = ({ body }) => {
    const url = `${host}${api_version}${key}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, body)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateSecondKeyStatus = ({ body }) => {
    const url = `${host}${api_version}${key}${spareKey}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, body)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const uploadChassisImage = (params, data) => {
    const url = `${host}${api_version}/v1${uploadChassis}${convertObjectToParams(
      params
    )}`;

    let formData = new FormData();
    formData.append('file', data.file);
    formData.append('appointmentId', data.appointmentId);

    return new Promise((resolve, reject) => {
      api
        .post(url, formData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getChassisImageUrl = (params) => {
    const url = `${host}${api_version}/v1${inventory}${chassis}`;

    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    getCarDetails,
    onMarkDocumentDispatch,
    onMarkDocumentReceived,
    onMarkDocumentLost,
    onMarkDocumentPending,
    getDocumentAuditLog,
    getDocumentAuditLogCount,
    updateInventorySoldField,
    getInventoryRefurbDetails,
    getInventoryRefurbDetailsForID,
    getPendingActions,
    getPendingActionsCount,
    getPendingActionsAuditLog,
    getPendingActionsAuditLogCount,
    setPendingAction,
    getHelloArStatus,
    getPendingPublishUpdatesAuditLog,
    updateInventoryAttributes,
    updateInventoryFlags,
    bulkInternalMovement,
    bulkSetLogisticVendor,
    bulkMoveOutAndPark,
    bulkSendVendorAssignedEmail,
    createNextHop,
    directStockIn,
    hardRefreshInventory,
    getInventoryOrderIds,
    updateRegistrationNumber,
    getKeyManagementAuditTrail,
    getKeyManagementAuditTrailCount,
    handleKeyMovement,
    updateSecondKeyStatus,
    uploadChassisImage,
    getChassisImageUrl,
  };
};
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
